import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import LastHolderFields from './LastHolderFields'
import useLastHolderFields from './useLastHolderFields'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'

const LastHolderFieldsModal = () => {
  const { t, hidden, isOpen, openModal, closeModal } = useLastHolderFields()

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='1rem' $marginBottom='1rem'>
      {/* @ts-ignore */}
      <SDOutlineButton onClick={openModal}>
        {t('subscriptionForm:address_module.last_holder_fields.name')}
      </SDOutlineButton>

      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:address_module.last_holder_fields.name')}
        sections={<LastHolderFields />}
      />
    </SpacingWrapper>
  )
}

export default LastHolderFieldsModal
